import { render, staticRenderFns } from "./BônusSemanal.vue?vue&type=template&id=2be566e7&scoped=true"
import script from "./BônusSemanal.vue?vue&type=script&lang=js"
export * from "./BônusSemanal.vue?vue&type=script&lang=js"
import style0 from "./BônusSemanal.vue?vue&type=style&index=0&id=2be566e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be566e7",
  null
  
)

export default component.exports